'use client';

import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import useInternetConnection from 'hooks/common/useInternetConnection';
import { addInternalNotification, removeInternalNotification } from 'store/reducers/InternalNotificationsSlice';

import { InAppNotificationItems } from 'constants/internalNotifications';

import { InternalNotificationsTypes, NotificationMessageType } from 'types/internalNotifications';

const useNoInternetNotifications = () => {
  const dispatch = useDispatch();

  const type = InternalNotificationsTypes.IN_APP;

  const onlineCallback = useCallback(() => {
    dispatch(removeInternalNotification({ id: NotificationMessageType.NO_INTERNET, type }));
  }, [dispatch, type]);

  const offlineCallback = useCallback(() => {
    const item = InAppNotificationItems[NotificationMessageType.NO_INTERNET];
    dispatch(addInternalNotification({ item, type }));
  }, [dispatch, type]);

  useInternetConnection({ onlineCallback, offlineCallback });
};

export default useNoInternetNotifications;
